export default "/assets/laying-14-bronzing.c3ebb0a34e74e45d3ee044bda1048158.jpeg";